export default __webpack_public_path__ + "xlsx_16x1.png";